import { Div, Snack, Span } from "@tblabs/truffle";
import { Server } from "../Services/Server";
import { TimeUtils } from "../Services/TimeUtils";
import { Heartbeat } from "./HeartbeatPayload";


export class StatusBar extends Div
{
    private statusDisplay = new Span("...").MarginTop(2);
    private heartbeatDisplay = new Span("").FloatRight().Color("#aaa");
    private historyBox = new Div();
    private timeoutSnack: Snack;

    constructor(private _server: Server)
    {
        super();

        this.Background("#222").Color("#f8f8f8")
            .Padding(8, 10)
            .Width(100, "%")
            .Cursor("pointer");

        let history: string[] = [];

        this.historyBox.Hide();

        this.OnClick(() => this.historyBox.Toggle());

        this._server.OnStatusChange.Subscribe((message) =>
        {
            history = history.slice(-16);
            history.push(message);

            this.historyBox.Clear();

            history.forEach((e, i) =>
            {
                if (i < history.length - 1)
                    this.historyBox.Append(new Div().BorderStyling("left", 4, "#444").PaddingLeft(6).Text(e));
            });

            this.statusDisplay.Text(message);
        });

        this._server.OnHeartbeat.Subscribe((heartbeat: Heartbeat) =>
        {
            if (heartbeat.IsBeating)
            {
                const heart = heartbeat.Counter % 2 ? '❤' : ' ';
                const timer = TimeUtils.SecondsToHHMMSS(heartbeat.Counter);
                this.heartbeatDisplay.Text(`${heart} ${timer}`)
            }
            else 
            {
                this.heartbeatDisplay.Text("💔 no heartbeat");
            }
        });

        this.Append(
            this.historyBox,
            new Div().Append(
                this.statusDisplay,
                this.heartbeatDisplay));
    }

    protected async OnRemove(): Promise<void>
    {
        if (this.timeoutSnack)
            this.timeoutSnack.Close();
    }
}
